import { socials } from './social';
import { userPage } from './userPage';
import { addPetWindow } from './addPetWindow';
import { storePages } from './storePages';
import { quizCounters } from './quiz';
import { market } from './market';
import { callButton } from './callButton';
import { marketQuiz } from './marketQuiz';
import { breedsWidget } from './breedsWidget';
import { consultationMainPage } from './consultationMainPage';
import type { IParamsCounters } from '@media-platform/analytic-counters';
import { consultationRubricPage } from './consultationRubricPage';
import { petsKindPage } from './petsKindPage';
import { kindRatingPage } from './kindRatingPage';
import { consultantPage } from './consultantPage';
import { addPetMain } from './addPetMain';
const counters = {
    // Счетчики
    common: {
        // счетчики виджета
        ...breedsWidget,
        // счетчики для кнопки звонка эксперту
        ...callButton,
        // счетчики для магазина
        ...market,
        // счетчики для теста
        ...marketQuiz,
        // счетчики для формы добавления питомца
        ...addPetWindow,
        ...socials,
        ...userPage,
        ...storePages,
        // счетчики в тесте
        ...quizCounters,
        // счетчики для главной консультации
        ...consultationMainPage,
        // счетчики для рубрики консультации
        ...consultationRubricPage,
        // счетчики для страницы консультанта
        ...consultantPage,
        // счетчики для страницы породы
        ...petsKindPage,
        // счетчики для страницы рейтинга пород
        ...kindRatingPage,
        // счетчики в анкете добавления питомца
        ...addPetMain,
        // клик по блоку
        blockClick: {
            rbmail: {
                type: 'click',
            },
        },
        // Ссылка в хлебных крошках
        articleBreadCrumbItemClick: {
            rbmail: {
                type: 'click',
                id: '28570607',
            },
        },
        // Кнопка в анкете питомцев
        addPetClick: {
            rbmail: {
                type: 'click',
                id: '154365432',
            },
        },
        //Клик по тизеру в рубриках
        rubricTeaserClick: {
            rbmail: {
                type: 'click',
            },
        },
        // Кнопка в блоке Породы
        articlePetsKindButtonClick: {
            rbmail: {
                type: 'click',
                id: '42708048',
            },
        },
        // GalleryGrid (article-item-type="gallery")
        articleGalleryGridItemClick: {
            rbmail: {
                type: 'click',
                id: '16457753',
            },
        },
        // Ссылки (readmore)
        articleReadmoreLinkClick: {
            rbmail: {
                type: 'click',
                id: '34730032',
            },
        },
        likeClick: {
            rbmail: {
                type: 'click',
                id: '28570621',
            },
        },
        friendForPetClick: {
            rbmail: {
                type: 'click',
                id: '61944597',
            },
        },
        friendForPetShow: {
            rbmail: {
                type: 'display',
                id: '61944597',
            },
        },
        mainProductClick: {
            rbmail: {
                type: 'click',
                id: '72009571',
            },
        },
        kindRatingItemClick: {
            rbmail: {
                type: 'click',
                id: '42708007',
            },
        },
        kindAllClick: {
            rbmail: {
                type: 'click',
                id: '42708014',
            },
        },
        consultationLinkClick: {
            rbmail: {
                type: 'click',
                id: '42707750',
            },
        },
        kindListingClick: {
            rbmail: {
                type: 'click',
                id: '42707958',
            },
        },
        compilationItemClick: {
            rbmail: {
                type: 'click',
                id: '42707892',
            },
        },
        compilationKindClick: {
            rbmail: {
                type: 'click',
                id: '42707882',
            },
        },
        suggestListingClick: {
            rbmail: {
                type: 'click',
                id: '42707762',
            },
        },
        consultationHeaderClick: {
            rbmail: {
                type: 'click',
                id: '28643874',
            },
        },
        consultationFilterClick: {
            rbmail: {
                type: 'click',
                id: '28643894',
            },
        },
        consultationAskButton: {
            rbmail: {
                type: 'click',
                id: '28643912',
            },
        },
        rubricFilterClick: {
            rbmail: {
                type: 'click',
                id: '28641902',
            },
        },
        appointmentButtonClickDesktop: {
            rbmail: {
                type: 'click',
                id: '154365440',
            },
        },
        appointmentButtonClickTouch: {
            rbmail: {
                type: 'click',
                id: '154365441',
            },
        },
    },
} as unknown as IParamsCounters;
export default counters;
